import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHandsHelping,
  faMedal,
  faHands,
  faRankingStar,
  faStar
} from '@fortawesome/free-solid-svg-icons';
import applausehubimage from '../../assets/pageimages/ApplauseHub.webp';

function ApplauseHubHome() {
  return (
    <div className="min-h-screen bg-black py-2">
      <div className='border-b border-blue-400'>
        <h2 className="text-lg lg:text-xl font-bold text-yellow-200 text-center mb-2">
          👏👍 Applause / Good Job
        </h2>
      </div>
      <div className="min-h-[90vh] px-4 space-y-6">
        <div className="bg-black p-4 rounded-xl shadow-xl flex flex-col lg:flex-row lg:gap-6 space-y-6 lg:space-y-0">
          {/* Marksheets Contest Section */}
          <div className="flex flex-col flex-1 border border-blue-500 rounded-lg p-4 bg-black">
            <p className="text-white text-center text-sm lg:text-m font-semibold mb-4">
              Turn Marksheets Into Mega Prizes
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <CardLink
                to="/i-applauded-marksheet"
                icon={faStar}
                text="Applauses for Marksheets"
              />
              <CardLink
                to="/applause-marksheet-contest"
                icon={faStar}
                text="About Contest"
              />
              <CardLink
                to="/applause-marksheet-leaderboard"
                icon={faRankingStar}
                text="Contest Leaderboard"
              />
              <CardLink
                to="/applause-marksheet-winners"
                icon={faMedal}
                text="Contest Winners"
              />
            </div>
          </div>

          {/* Applauses Section */}
          <div className="flex flex-col flex-1 border border-blue-500 rounded-lg p-4 bg-black">
            <p className="text-white text-center text-sm lg:text-m font-semibold mb-4">
              Applauses & Self Recognition
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <CardLink to="/i-applauded" icon={faHandsHelping} text="I Applauded" />
              <CardLink to="/self-applause" icon={faHands} text="Self Applause" />
              <CardLink to="/applause-for-me" icon={faMedal} text="Applause For Me" />
            </div>
          </div>
        </div>      

        <SectionCard>
          <CardLink to="/noteflex-home" icon={faStar} text="Think NoteFlex" />
          <CardLink to="/contact-genious/business" icon={faStar} text="Multimedia Digital Card" />
          <CardLink
            to="/orderflow-earning-estimator"
            icon={faStar}
            text="Earn Active & Passive Income to Support Your Study or Family"
          />
        </SectionCard>

        <SectionCard>
          <CardLink to="/applause-game" icon={faStar} text="Think5Whys Applause Game" />
          <CardLink to="/applause-game-rules" icon={faStar} text="Think5Whys Applause Game Rules" />
        </SectionCard>

      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}

/* ---- REUSABLE COMPONENTS ---- */

const SectionCard = ({ children }) => (
  <div className="bg-black border border-blue-500 rounded-xl p-6 shadow-xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {children}
  </div>
);

const CardLink = ({ to, icon, text }) => (
  <Link
    to={to}
    className="flex items-center bg-gray-900 border border-blue-600 rounded-lg p-3 shadow-md 
               text-blue-200 hover:bg-gray-800 hover:border-blue-400 transition-all"
  >
    <FontAwesomeIcon icon={icon} className="text-xl mr-3 text-blue-300" />
    <span className="text-sm lg:text-m">{text}</span>
  </Link>
);

export default ApplauseHubHome;
